export const isString = (propertie) => typeof propertie === 'string';

export const hasValue = (value) => value || '';

export const setDefaultValueContactColumns = (
  contactColumns,
  { name, contactIdentifier },
) => {
  return contactColumns.map((column) => {
    if (column.database == 'fullname') {
      column.value = name;
    }
    if (column.database == 'whatsapp_identifier') {
      column.value = contactIdentifier;
      column.show = 'N';
    }

    return column;
  });
};

export const setDefaultValueContactColumnsVoice = (job) => (contactColumns) =>
  contactColumns.map((column) => {
    if (column.database == 'phone1') column.value = job.phone;
    return column;
  });

export const isArray = (value) => Array.isArray(value);

export const hasPropertyObject = (property, target) =>
  target.hasOwnProperty(property);

export const removeKeysFieldScript = (dirtField) =>
  dirtField.replace(/[{}]/g, '');

export const removePrefixFieldScript = (field, prefix) =>
  field.replace(new RegExp(prefix, 'g'), '');

export const outhersAgents = (agentId) => (agents) =>
  agents.filter((agent) => agent.id != agentId);

export const trimPhoneNumber = (dirtyPhone) =>
  dirtyPhone.replace(/[^0-9]/g, '');

export const trimVoicePhoneNumber = (dirtyPhone) =>
  dirtyPhone.replace(/[^0-9]/g, '');

export const urlAPI = () => {
  const url =
    process.env.NODE_ENV == 'development'
      ? process.env.API_URL
      : window.CONFIG.weactionapi.url;
  return url.slice(0, -1);
};

export const verifyIfIsUnsupportedBrowser = () => {
  const isFirefox = typeof InstallTrigger !== 'undefined';
  const isChrome = !!window.chrome;
  if (isChrome) {
    const chromePosition = navigator.userAgent.indexOf('Chrome');
    const version = navigator.userAgent
      .substring(chromePosition + 7)
      .substring(0, 3);
    return version < 71;
  }

  if (isFirefox) {
    const firefoxPosition = navigator.userAgent.indexOf('Firefox');
    const version = navigator.userAgent
      .substring(firefoxPosition + 8)
      .substring(0, 3);
    return version < 60;
  }
  return true;
};

export const download = (url) => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', '');
  link.setAttribute('target', '_blank');
  link.click();
};

export const truncate = (text, maxlength) => {
  if (!text) return '';

  return (
    String(text).slice(0, maxlength) + (maxlength < text.length ? '...' : '')
  );
};

export const initialsOfName = (name) => {
  if (!name) return '';

  const fullname = name.replace(/\s(de|da|dos|das)\s/g, ' ');
  const initials = fullname.match(/\b(\w)/gi);
  const firstName = fullname.split(' ')[0].toUpperCase();
  const initialName = firstName.charAt(0);
  const surname = initials
    .splice(1, initials.length - 1)
    .join('')
    .toUpperCase();

  return `${initialName}${surname.length > 1 ? surname.charAt(1) : surname}`;
};

export const formatCnpj = (employerCnpj) => {
  if (!employerCnpj) return '';
  if (employerCnpj.length != 14) return employerCnpj;

  return employerCnpj.length == 14
    ? employerCnpj.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5',
      )
    : '';
};

export const contactColor = (name) => {
  let contactName = name;

  const colors = [
    '#ED2D2D',
    '#F00055',
    '#FE0089',
    '#D138B0',
    '#A400F1',
    '#6E00FB',
    '#366CF6',
    '#2196F3',
    '#00A8C2',
    '#00BEB3',
    '#0CA678',
    '#0CA625',
    '#77CD00',
    '#FFC53A',
    '#F59F00',
    '#F59F00',
    '#FF00B8',
    '#B600C6',
    '#01579B',
    '#0189B4',
    '#017B8E',
    '#00867E',
    '#DD3429',
    '#A61E4D',
    '#AB5D01',
    '#870075',
    '#F5683B',
  ];

  let hash = 0;
  for (let i = 0; i < contactName.length; i++) {
    hash = contactName.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash % colors.length)];
};

export const checkMessageType = (message) => {
  const extension = message.split('.').pop();

  const imageExtensions = ['jpg', 'jpeg', 'png'];
  const videoExtensions = ['mp4', 'mov', 'avi'];
  const audioExtensions = ['mp3', 'wav', 'ogg'];
  const documentExtensions = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
  ];

  if (imageExtensions.includes(extension)) {
    return 'image';
  }

  if (videoExtensions.includes(extension)) {
    return 'video';
  }

  if (audioExtensions.includes(extension)) {
    return 'text';
  }

  if (documentExtensions.includes(extension)) {
    return 'document';
  }

  return 'text';
};

export function extractValidUrl(message) {
  if (typeof message !== 'string') return '';

  const unescaped = message.replace(/\\\//g, '/');

  const urlRegex =
    /(https?:\/\/[\w\-._~:/?#[\]@!$&'()*+,;=%]+)(?![\w\-._~:/?#[\]@!$&'()*+,;=%])/i;
  const match = unescaped.match(urlRegex);

  if (match && match[1]) {
    try {
      const url = new URL(match[1]);
      return url.href;
    } catch (e) {
      return message;
    }
  }
  return message;
}

export function stripQuotes(str) {
  if (!str) return '';
  return str.replace(/^"+|"+$/g, '');
}

export const normalizeMessage = (message) => {
  try {
    const messageParsed = JSON.parse(message);

    if (
      (typeof messageParsed === 'object' ||
        typeof messageParsed === 'string') &&
      messageParsed !== null
    ) {
      return messageParsed;
    }

    throw new Error('Mensagem não é um JSON válido');
  } catch (error) {
    return message;
  }
};

export function manualUnescape(str) {
  if (!str) return '';
  return str
    .replace(/\\\\/g, '\\') // double backslash to single
    .replace(/\\n/g, '\n') // \n to newline
    .replace(/\\"/g, '"') // \" to "
    .replace(/\\'/g, "'") // \\' to '
    .replace(/\\\//g, '/'); // \/ to /
}

/**
 * normalizeChatIdentifier
 * Responsável por normalizar o identificador de um chat removendo '-', '.', '/' (máscara CPF/CNPJ)
 * @param {string} identifier
 * @returns {string}
 */
export const normalizeChatIdentifier = (identifier) => {
  return identifier.replace(/[./-]/g, '');
};
